export default __webpack_public_path__ + "static/media/map-icon.19ee518a.png";